import {makeStyles, Popover} from '@material-ui/core'
import React from 'react'

const usePopoverStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(4),
  },
}))

function StyledPopover(props) {
  const menuClasses = usePopoverStyles()

  return (
    <Popover
      marginThreshold={0}
      disableScrollLock={true}
      getContentAnchorEl={null}
      classes={{
        paper: menuClasses.paper,
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      disableRestoreFocus
      {...props}
    />
  )
}

export {StyledPopover}
